import { computed } from '@ember/object';
import { fragment } from 'ember-data-model-fragments/attributes';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import { condition } from '@square/dashboard-utilities/macros';
export default EmberDataBaseModel.extend({
  cardPresent: fragment('processing-fee'),
  cardNotPresent: fragment('processing-fee'),
  cardOnFile: fragment('processing-fee'),
  ecomSosFree: fragment('processing-fee'),
  ecomSosPremium: fragment('processing-fee'),
  nonEuEcomSosFree: fragment('processing-fee'),
  nonEuEcomSosPremium: fragment('processing-fee'),
  invoice: fragment('processing-fee'),
  invoiceCardOnFile: fragment('processing-fee'),
  invoiceDashboard: fragment('processing-fee'),
  invoicesAch: fragment('processing-fee'),
  invoicesAchPlus: fragment('processing-fee'),
  invoicesAfterpay: fragment('processing-fee'),
  invoicesCashappPay: fragment('processing-fee'),
  invoicesPayPageFree: fragment('processing-fee'),
  invoicesPayPagePlus: fragment('processing-fee'),
  externalApi: fragment('processing-fee'),
  nonEuExternalApi: fragment('processing-fee'),
  terminal: fragment('processing-fee'),
  terminalCardOnFile: fragment('processing-fee'),
  registerHardware: fragment('processing-fee'),
  registerT2: fragment('processing-fee'),
  interac: fragment('processing-fee'),
  visaMastercardCardPresent: fragment('processing-fee'),
  americanExpressCardPresent: fragment('processing-fee'),
  cafisJcb: fragment('processing-fee'),
  cafisDiscoverDiners: fragment('processing-fee'),
  cafisJcbKeyed: fragment('processing-fee'),
  cafisDiscoverDinersKeyed: fragment('processing-fee'),
  cafisJcbInvoice: fragment('processing-fee'),
  cafisDiscoverDinersInvoice: fragment('processing-fee'),
  cafisDiscoverDinersInvoiceDashboard: fragment('processing-fee'),
  cafisJcbInvoiceCardOnFile: fragment('processing-fee'),
  cafisJcbInvoiceDashboard: fragment('processing-fee'),
  cafisDiscoverDinersInvoiceCardOnFile: fragment('processing-fee'),
  cafisJcbTerminal: fragment('processing-fee'),
  cafisJcbTerminalOnFile: fragment('processing-fee'),
  cafisDiscoverDinersTerminal: fragment('processing-fee'),
  cafisDiscoverDinersTerminalOnFile: fragment('processing-fee'),
  cafisJcbExternalApi: fragment('processing-fee'),
  cafisJcbEcomFree: fragment('processing-fee'),
  cafisJcbEcomPremium: fragment('processing-fee'),
  cafisDiscoverDinersExternalApi: fragment('processing-fee'),
  cafisDiscoverDinersEcomFree: fragment('processing-fee'),
  cafisDiscoverDinersEcomPremium: fragment('processing-fee'),
  retailPosFree: fragment('processing-fee'),
  retailPosPaid: fragment('processing-fee'),
  restaurantsPosFree: fragment('processing-fee'),
  restaurantsPosPaid: fragment('processing-fee'),
  riskManagerFree: fragment('processing-fee'),
  riskManagerPaid: fragment('processing-fee'),
  appointmentsPosFree: fragment('processing-fee'),
  appointmentsPosPaid: fragment('processing-fee'),
  appointmentsObsKeyed: fragment('processing-fee'),
  appointmentsObsOnFile: fragment('processing-fee'),
  nonEuAppointmentsObsKeyed: fragment('processing-fee'),
  nonEuAppointmentsObsOnFile: fragment('processing-fee'),
  payPayPos: fragment('processing-fee'),
  rakutenPayPos: fragment('processing-fee'),
  merpayPos: fragment('processing-fee'),
  weChatPayPos: fragment('processing-fee'),
  dBaraiPos: fragment('processing-fee'),
  auPayPos: fragment('processing-fee'),
  alipayPos: fragment('processing-fee'),
  felicaIdPos: fragment('processing-fee'),
  felicaQpPos: fragment('processing-fee'),
  felicaTransportationPos: fragment('processing-fee'),
  giftCardLoad: fragment('processing-fee'),
  paymentLinks: fragment('processing-fee'),
  // TODO(kh) replace this when web sends this info
  // pickup: fragment('processing-fee'),

  sameRate: computed('cardPresent', 'cardNotPresent', function () {
    return this.cardPresent.equals(this.cardNotPresent);
  }),
  // Dictates whether Cafis rates (JCB and Discover Diners) will display in
  // the same table or separately.
  sameCafisRate: computed('cafisJcb', 'cafisDiscoverDiners', 'cafisJcbKeyed', 'cafisDiscoverDinersKeyed', 'cafisJcbInvoice', 'cafisDiscoverDinersInvoice', 'cafisDiscoverDinersInvoiceDashboard', 'cafisJcbInvoiceCardOnFile', 'cafisJcbInvoiceDashboard', 'cafisDiscoverDinersInvoiceCardOnFile', 'cafisJcbTerminal', 'cafisJcbTerminalOnFile', 'cafisDiscoverDinersTerminal', 'cafisDiscoverDinersTerminalOnFile', 'cafisJcbExternalApi', 'cafisDiscoverDinersExternalApi', 'cafisJcbEcomFree', 'cafisDiscoverDinersEcomFree', 'cafisJcbEcomPremium', 'cafisDiscoverDinersEcomPremium', function () {
    const registerEqual = this.cafisJcb.equals(this.cafisDiscoverDiners) && this.cafisJcbKeyed.equals(this.cafisDiscoverDinersKeyed);
    const invoicesEqual = !this.cafisJcbInvoice || this.cafisJcbInvoice.equals(this.cafisDiscoverDinersInvoice);
    const invoicesOnFileEqual = !this.cafisJcbInvoiceCardOnFile || this.cafisJcbInvoiceCardOnFile.equals(this.cafisDiscoverDinersInvoiceCardOnFile);
    const invoiceDashboardEqual = !this.cafisJcbInvoiceDashboard || this.cafisJcbInvoiceDashboard.equals(this.cafisDiscoverDinersInvoiceDashboard);
    const externalApiEqual = this.cafisJcbExternalApi.equals(this.cafisDiscoverDinersExternalApi);
    const ecomFreeEqual = this.cafisJcbEcomFree.equals(this.cafisDiscoverDinersEcomFree);
    const ecomPremiumEqual = this.cafisJcbEcomPremium.equals(this.cafisDiscoverDinersEcomPremium);
    const terminalEqual = this.cafisJcbTerminal.equals(this.cafisDiscoverDinersTerminal) && this.cafisJcbTerminalOnFile.equals(this.cafisDiscoverDinersTerminalOnFile);
    return registerEqual && invoicesEqual && invoicesOnFileEqual && invoiceDashboardEqual && externalApiEqual && ecomFreeEqual && ecomPremiumEqual && terminalEqual;
  }),
  // Check both CP and CNP to find a Cost+ fee rate.
  // TODO(kaneda): Fix this condition. We currently assume that Cost+ fee is applied
  // to every product/entry method.
  costPlusRate: condition('cardPresent.costPlusFeeRate', {
    then: 'cardPresent.costPlusFeeRate',
    else: 'cardNotPresent.costPlusFeeRate'
  }),
  // In Interchange+, fees are being applied to every product/entry method
  interchangePlusRate: condition('cardPresent.interchangePlusFeeRate', {
    then: 'cardPresent.interchangePlusFeeRate',
    else: 'cardNotPresent.interchangePlusFeeRate'
  })
}).reopenClass({
  _modelNameForMigration: 'processing-fees'
});